import axios from "axios";
import moment from "moment/moment";
import {da} from "vuetify/locale";

const TaskSprintStore = {
    state: () => ({
        tasks: [],
        filtriClient: {},
        lastFetch:0,
        filtriRequest:{}
    }),
    mutations: {
        expandTaskSprint(state, item) {
            return item;
        },

        droppedTask(state, item) {
            return item;
        },

        editTaskDOD(state, item) {
            return item
        },

        dodModificata(state, item) {
            return item
        },
        tasksLoaded(state, item) {
            item.forEach((el) => {
                if (!el.style)
                    el.style = {};
            })
            state.tasks = [...item];
            state.lastFetch=moment().unix();
        },

        statusUpdated(state, item) {
            state.tasks.forEach((el) => {
                if (el.id === item.id) {
                    el.status = item.status;
                    el.style.top = undefined;
                    el.style.left = undefined;
                    //el.startDate = item.startDate;
                    //el.endDate = item.endDate;
                    el.tag = item.tag;
                    return;
                }
            })
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", [...state.tasks])
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
            this.commit("updateEsecutoriTasks", state.tasks);
        },

        dodEdited(state, item) {
            state.tasks.forEach((el) => {
                if (el.id === item.id) {
                    el.descrizione = item.descrizione;
                    return;
                }
            })
        },

        tasksUpdated(state, item) {
            state.tasks.forEach((el) => {
                if (el.id === item.id) {
                    el.descrizione = item.descrizione||el.descrizione;
                    el.orePreviste = item.orePreviste||el.orePreviste;
                    el.richiedeApprovazione = item.richiedeApprovazione||el.richiedeApprovazione;
                    el.tag=item.tag||el.tag;
                    el.startDate=item.startDate||el.startDate;
                    return;
                }
            })
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", [...state.tasks])
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
        },

        updateTaskPosition(state, item) {
            state.tasks.forEach((el) => {
                if (el.id === item.id) {
                    el.style = {};
                    el.style.top = item.top;
                    el.style.left = item.left
                    return;
                }
            })
            return item
        },

        storeUpdateTasks(state, item) {
            const sourceMap = new Map(item.tasks.map(item => [item.id, item]));
            state.tasks = [...state.tasks.map(item => sourceMap.get(item.id) || item)];
        },

        getDescrizioneLavoro(state, item) {
            return item
        },

        getDettaglioTicket(state, item) {
            return item
        },
        creaTaskSprint(state, item) {
            return item;
        },


        tasksCreated(state, item) {
            state.tasks = [...state.tasks, item];
            this.commit("taskLoadedPM", [...state.tasks])
            this.commit("tasksLoaded", [...state.tasks])
            return { tuttiTS: state.tasks, tsCreato: item };
        },
        ownerUpdated(state, item) {
            state.tasks.forEach(task => {
                if (task.id === item.id) {
                    task.status = item.status;
                    task.idOwner = Number.parseInt(item.idOwner);
                    task.descrizione=item.descrizione;
                    task.style = {};
                    return;
                }
            });
            this.commit("taskLoadedPM", [...state.tasks])
            this.commit("tasksLoaded", [...state.tasks])
            return item
        },
        filtriApplicati(state, item) {
            state.filtriClient = { ...item };
        },
        filtraTasks(state, item) {
            return item
        },
        filtraRequest(state, item) {
            state.filtriRequest = { ...item };
            return item
        },
        tuttiITaskCompletati(state, item) {
            return item;
        },
        taskDaAggiornare(state, item){
            return item
        },
        taskEliminato(state, item) {
            let taskFIltered = state.tasks.filter(ts => ts.id !== item.id);
            state.tasks = [...taskFIltered];

            this.commit("taskLoadedPM", [...state.tasks])
            this.commit("tasksLoaded", state.tasks)
        },
        tutteLeAttivitaCaricate(state, item) {
            let taskDaAggiornare=[];
            state.tasks.forEach(task => {
                let attivitaTS = item.filter(att => att.id_ticket === task.idTicket);
                if (attivitaTS.length >= 1){
                    if(attivitaTS[0]?.titolo!==task.titoloAttivita){
                        task.titoloAttivita = attivitaTS[0]?.titolo;
                        taskDaAggiornare.push({
                            idTaskSprint:task.id,
                            idTicket:task.idTicket,
                            titoloAttivita:attivitaTS[0]?.titolo
                        })
                    }
                }
            });
            this.commit("taskDaAggiornare", [...taskDaAggiornare])
        },

        attivitaSenzaLavoroCaricate(state, item) {
            let taskDaAggiornare=[];
            state.tasks.forEach(task => {
                let attivitaTS = item.filter(att => att.id_ticket === task.idTicket);
                if (attivitaTS.length >= 1){
                    if(attivitaTS[0]?.titolo!==task.titoloAttivita){
                        task.titoloAttivita = attivitaTS[0]?.titolo;
                        taskDaAggiornare.push({
                            idTaskSprint:task.id,
                            idTicket:task.idTicket,
                            titoloAttivita:attivitaTS[0]?.titolo
                        })
                    }
                }
            });
            this.commit("taskDaAggiornare", [...taskDaAggiornare])
        },
        lavoriCaricati(state, item) {
            let taskDaAggiornare=[];
            state.tasks.forEach(task => {
                let lavoroTS = item.filter(lav => lav.id_ticket === task.idTicketParent);
                if (lavoroTS.length >= 1){
                    if(lavoroTS[0]?.titolo!==task.titoloLavoro){
                        task.titoloLavoro = lavoroTS[0]?.titolo;
                        taskDaAggiornare.push({
                            idTaskSprint:task.id,
                            idTicket:task.idTicket,
                            idTicketParent:task.idTicketParent,
                            titoloLavoro:lavoroTS[0]?.titolo
                        })
                    }
                }
            });
            this.commit("taskDaAggiornare", [...taskDaAggiornare])
        },
        taskGestito(state, item){
            let approvato=item.approvato;
            let idTask=item.idTaskSprint;
            let messaggio=item.messaggio;
            state.tasks.forEach(task=>{
                if(task.id===idTask){
                    task.style = {};
                    task.messaggio=messaggio;
                    if(approvato){
                        task.status='DONE'
                        task.tag="APPROVATO"
                    }else{
                        task.status='TODO';
                        task.tag="RIFIUTATO";

                    }
                    return;
                }
            });
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }

        },
        taskRicaricati(state, item){
            let nuoviTS=[...item];
            let tuttiTS=[...state.tasks];
            nuoviTS.forEach(ts=>{
                let indexOf=tuttiTS.findIndex(t=>t.id==ts.id);
                ts.style={};
                if(indexOf===-1){
                    tuttiTS.push(ts)
                }else{
                    tuttiTS[indexOf]=ts;
                }
            });
            state.tasks=[...tuttiTS];
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...tuttiTS])
                this.commit("tasksLoaded", [...tuttiTS])
            }else{
                this.commit("tasksLoaded", [...tuttiTS])
            }
            // this.commit("taskLoadedPM", [...tuttiTS])
            // this.commit("tasksLoaded", [...tuttiTS])
        },
        storiaTaskLoaded(state, item){
            let storiaTs=[];
            let storia=item.storia;
            let storiaNuova;
            if(storia.length>1){
                storia.sort((s1, s2)=>s1.lastUpdate-s2.lastUpdate)

                storiaNuova=storia[0];
                let modificheStoria=[];
                for(let i=1;i<storia.length; i++){
                    let s=storia[i];
                    modificheStoria.push({
                        idUtenteModifica:s.idUtenteModifica,
                        lastUpdate:s.lastUpdate,
                        messaggio:s.messaggio,
                        status:s.status,
                        tag:s.tag
                    });
                    for(let modifica of s.modifiche){
                        modificheStoria.push(modifica)
                    }
                }
                storiaNuova.modifiche=[...modificheStoria];
                storia=[];
                storia.push(storiaNuova);
            }


            let owner=storia.idOwner;
            let visulizzaOwner=false;
            if(storia.length>0){
                storia=storia[0];
                storiaTs.push({
                    idOwner:storia.idOwner,
                    idUtenteModifica:storia.idCreatedBy,
                    status:storia.status,
                    messaggio:storia.descrizione,
                    lastUpdate:epochToDate(storia.lastUpdate),
                    lastUpdateEpoch:storia.lastUpdate
                })
                storia?.modifiche?.forEach(modifica=>{
                    // if(modifica.idOwner && modifica?.idOwner!==owner){
                    //     visulizzaOwner=true
                    // }
                    if(visulizzaOwner|| modifica?.status||modifica?.messaggio||modifica?.descrizione){

                        if(modifica.descrizione&&storiaTs[storiaTs.length-1]?.messaggio!==modifica.descrizione){
                            modifica.messaggio='SYS: DOD MODIFICATA: \n'+modifica.descrizione
                        }

                        if(!modifica?.messaggio && modifica?.status){
                            modifica.messaggio='SYS: Il Task ha cambiato stato';
                        }
                        if(!modifica?.status){
                            modifica.status=storiaTs[storiaTs.length-1]?.status
                        }

                        storiaTs.push({
                            idOwner:modifica?.idOwner,
                            status:modifica?.status,
                            idUtenteModifica:modifica.idUtenteModifica,
                            messaggio:modifica?.messaggio,
                            lastUpdate:epochToDate(modifica.lastUpdate),
                            lastUpdateEpoch:modifica.lastUpdate
                        })
                    }

                })

            }
            storiaTs.sort((s1, s2)=>s2.lastUpdateEpoch-s1.lastUpdateEpoch)
            this.commit("visualizzaStoriaTS", {
                storico:[...storiaTs],
                visulizzaOwner:visulizzaOwner,
                titoloAttivita:item.titoloAttivita,
                titoloLavoro:item.titoloLavoro,
                idTaskSprint:item.idTaskSprint
            })
        },

        storiaTaskLoadedFromNotifica(state, item){
            let storiaTs=[];
            let storia=item.storia;
            let owner=storia.idOwner;
            let visulizzaOwner=false;
            let storiaNuova;
            if(storia.length>1){
                storia.sort((s1, s2)=>s1.lastUpdate-s2.lastUpdate)

                storiaNuova=storia[0];
                let modificheStoria=[];
                for(let i=1;i<storia.length; i++){
                    let s=storia[i];
                    modificheStoria.push({
                        idUtenteModifica:s.idUtenteModifica,
                        lastUpdate:s.lastUpdate,
                        messaggio:s.messaggio,
                        status:s.status,
                        tag:s.tag
                    });
                    for(let modifica of s.modifiche){
                        modificheStoria.push(modifica)
                    }
                }
                storiaNuova.modifiche=[...modificheStoria];
                storia=[];
                storia.push(storiaNuova);
            }


            if(storia.length>0){
                storia=storia[0];
                storiaTs.push({
                    idOwner:storia.idOwner,
                    idUtenteModifica:storia.idCreatedBy,
                    status:storia.status,
                    messaggio:storia.descrizione,
                    lastUpdate:epochToDate(storia.lastUpdate),
                    lastUpdateEpoch:storia.lastUpdate
                })
                storia?.modifiche?.forEach(modifica=>{
                    // if(modifica.idOwner && modifica?.idOwner!==owner){
                    //     visulizzaOwner=true
                    // }
                    if(visulizzaOwner|| modifica?.status||modifica?.messaggio||modifica?.descrizione){

                        if(modifica.descrizione&&storiaTs[storiaTs.length-1]?.messaggio!==modifica.descrizione){
                            modifica.messaggio='SYS: DOD MODIFICATA: \n'+modifica.descrizione
                        }

                        if(!modifica?.messaggio && modifica?.status){
                            modifica.messaggio='SYS: Il Task ha cambiato stato';
                        }
                        if(!modifica?.status){
                            modifica.status=storiaTs[storiaTs.length-1]?.status
                        }

                        storiaTs.push({
                            idOwner:modifica?.idOwner,
                            status:modifica?.status,
                            idUtenteModifica:modifica.idUtenteModifica,
                            messaggio:modifica?.messaggio,
                            lastUpdate:epochToDate(modifica.lastUpdate),
                            lastUpdateEpoch:modifica.lastUpdate
                        })
                    }

                })

            }
            storiaTs.sort((s1, s2)=>s2.lastUpdateEpoch-s1.lastUpdateEpoch)
            this.commit("visualizzaStoriaTSFromNotifica", {
                storico:[...storiaTs],
                visulizzaOwner:visulizzaOwner,
                titoloAttivita:item.titoloAttivita,
                titoloLavoro:item.titoloLavoro,
            })
        },
        visualizzaStoriaTS(state, item){
            return item;
        },
        visualizzaStoriaTSFromNotifica(state, item){
            return item;
        },
        storiaTaskLoadedFromDettaglio(state, item){
            let storiaTs=[];
            let storia=item.storia;
            let storiaNuova;
            if(storia.length>1){
                storia.sort((s1, s2)=>s1.lastUpdate-s2.lastUpdate)

                storiaNuova=storia[0];
                let modificheStoria=[];
                for(let i=1;i<storia.length; i++){
                    let s=storia[i];
                    modificheStoria.push({
                        idUtenteModifica:s.idUtenteModifica,
                        lastUpdate:s.lastUpdate,
                        messaggio:s.messaggio,
                        status:s.status,
                        tag:s.tag
                    });
                    for(let modifica of s.modifiche){
                        modificheStoria.push(modifica)
                    }
                }
                storiaNuova.modifiche=[...modificheStoria];
                storia=[];
                storia.push(storiaNuova);
            }


            let owner=storia.idOwner;
            let visulizzaOwner=false;
            if(storia.length>0){
                storia=storia[0];
                storiaTs.push({
                    idOwner:storia.idOwner,
                    idUtenteModifica:storia.idCreatedBy,
                    status:storia.status,
                    messaggio:storia.descrizione,
                    lastUpdate:epochToDate(storia.lastUpdate),
                    lastUpdateEpoch:storia.lastUpdate
                })
                storia?.modifiche?.forEach(modifica=>{
                    // if(modifica.idOwner && modifica?.idOwner!==owner){
                    //     visulizzaOwner=true
                    // }
                    if(visulizzaOwner|| modifica?.status||modifica?.messaggio||modifica?.descrizione){

                        if(modifica.descrizione&&storiaTs[storiaTs.length-1]?.messaggio!==modifica.descrizione){
                            modifica.messaggio='SYS: DOD MODIFICATA: \n'+modifica.descrizione
                        }

                        if(!modifica?.messaggio && modifica?.status){
                            modifica.messaggio='SYS: Il Task ha cambiato stato';
                        }
                        if(!modifica?.status){
                            modifica.status=storiaTs[storiaTs.length-1]?.status
                        }

                        storiaTs.push({
                            idOwner:modifica?.idOwner,
                            status:modifica?.status,
                            idUtenteModifica:modifica.idUtenteModifica,
                            messaggio:modifica?.messaggio,
                            lastUpdate:epochToDate(modifica.lastUpdate),
                            lastUpdateEpoch:modifica.lastUpdate
                        })
                    }

                })

            }
            storiaTs.sort((s1, s2)=>s2.lastUpdateEpoch-s1.lastUpdateEpoch)
            this.commit("visualizzaStoriaTSFromDettaglio", {
                storico:[...storiaTs],
                visulizzaOwner:visulizzaOwner
            })
        },
        visualizzaStoriaTSFromDettaglio(state, item){
          return item
        },
        tasksCreatedFromWs(state, item){
            let ts=state.tasks;
            let index=-1;
            for(let i=0; i<ts.length; i++ ){
                if(ts[i].id==item.id){
                    index=i;
                    break;
                }
            }

            // if(index>0){
            //     ts=ts.splice(index, 1);
            // }
            // ts.push(item);

            if(index<0){
                ts.push(item);
            }

            state.tasks=[...ts]
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", [...state.tasks])
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }


        },
        taskDeletedFromWs(state, item){
            let taskFIltered = state.tasks.filter(ts => ts.id !== item);
            state.tasks = [...taskFIltered];
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }


        },
        taskUpdatedFromWs(state, item){

            let taskFIltered = state.tasks.filter(ts => ts.id !== item);
            state.tasks.forEach(ts=>{
                if(ts.id===item.id){
                    ts.descrizione=item.descrizione||ts.descrizione;
                    ts.orePreviste=item.orePreviste||ts.orePreviste;
                    ts.richiedeApprovazione=item.richiedeApprovazione|| ts.richiedeApprovazione;
                    ts.lastUpdate=item.lastUpdate;
                    ts.tag=item.tag||ts.tag;
                    ts.startDate=item.startDate||ts.startDate;
                    ts.idAnagraficaRelazione=item.idAnagraficaRelazione||ts.idAnagraficaRelazione;
                    ts.labelAnagraficaRelazione=item.labelAnagraficaRelazione||ts.labelAnagraficaRelazione;
                    if(item.idTicketCategoria){
                        ts.idTicketCategoria=item.idTicketCategoria
                    }else {
                        item.idTicketCategoria =ts.idTicketCategoria;
                    }
                    if(item.titoloLavoro){
                        ts.titoloLavoro=item.titoloLavoro;
                    }
                    if(item.idTicketParent){
                        ts.idTicketParent=item.idTicketParent;
                    }
                    ts.forcePM=item.forcePM;
                    ts.idPmForzato=item.idPmForzato
                    ts.effortEvaluation=item.effortEvaluation;
                    ts.effortEvaluationTS=item.effortEvaluationTS;
                    ts.startWorkingTS=item.startWorkingTS;
                    ts.effortRevisionRequested=item.effortRevisionRequested;
                    if(item.effortRevisionRequestedTS){
                        ts.effortRevisionRequestedTS=item.effortRevisionRequestedTS;
                    }else{
                        ts.effortRevisionRequestedTS=0;
                    }

                }
            })

            if(item.idTicketCategoria){
                let idTicketCategorie=JSON.parse(sessionStorage.getItem('ticketCategorie'));
                if(idTicketCategorie.findIndex(c=>c===item.idTicketCategoria)<0){
                    let taskFiltered = state.tasks.filter(ts => ts.id !== item.id);
                    state.tasks = [...taskFiltered];
                }
            }


            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
            //state.tasks = [...taskFIltered];
            // this.commit("taskLoadedPM", [...state.tasks])
            // this.commit("tasksLoaded", state.tasks)
        },
        taskUpdatedStatusFromWs(state, item){
            let ts=state.tasks;
            let index=-1;
            for(let i=0; i<state.tasks.length; i++ ){
                if(state.tasks[i].id==item.id){
                    index=i;
                    break;
                }
            }
            state.tasks.forEach(ts=>{
                if(ts.id===item.id){
                    ts.status=item.status;
                    ts.lastUpdate=item.lastUpdate;
                    ts.startDate=item.startDate||ts.startDate;
                    ts.messaggio=item.messaggio;
                    ts.tag=item.tag||ts.tag
                }
            })
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
        },
        taskGestitoWs(state, item){
            let approvato=item.approvato;
            let idTask=item.id;
            let messaggio=item.messaggio;
            state.tasks.forEach(task=>{
                if(task.id===idTask){
                    task.style = {};
                    task.messaggio=messaggio;
                    if(item.tag==='APPROVATO'){
                        task.status='DONE'
                        task.tag="APPROVATO"
                    }else{
                        task.status='TODO';
                        task.tag="RIFIUTATO";

                    }
                    return;
                }
            });
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
        },
        taskUpdatedOwnerWs(state, item){
            let myUserId=sessionStorage.getItem('userId');
            let imPM=sessionStorage.getItem('isPM')
            let task=item.messageContent
            let newOwner=item.idOwner;
            let oldOwner=item.oldIdOwner;
            if(myUserId==oldOwner &&imPM==='false'){
                let taskFIltered = state.tasks.filter(ts => ts.id !== task.id);
                state.tasks = [...taskFIltered];
                if(imPM==='true'){
                    this.commit("taskLoadedPM", [...state.tasks])
                    this.commit("tasksLoaded", state.tasks)
                }else{
                    this.commit("tasksLoaded", [...state.tasks])
                }
            }else{
                let idTicketCategorie=JSON.parse(sessionStorage.getItem('ticketCategorie'));
                if(task.idTicketCategoria){
                    if(idTicketCategorie.findIndex(tc=>tc===task.idTicketCategoria)<0)
                        return;
                }

                let index=-1;
                for(let i=0; i<state.tasks.length; i++ ){
                    if(state.tasks[i].id==task.id){
                        index=i;
                        break;
                    }
                }
                if(index===-1 && newOwner==myUserId){
                    state.tasks.push(task);
                    // this.commit("taskLoadedPM", [...state.tasks])
                    // this.commit("tasksLoaded", state.tasks)
                }else if(index!==-1){
                    state.tasks[index].idOwner=newOwner;
                    // this.commit("taskLoadedPM", [...state.tasks])
                    // this.commit("tasksLoaded", state.tasks)
                }
                let imPM=sessionStorage.getItem('isPM')
                if(imPM==='true'){
                    this.commit("taskLoadedPM", [...state.tasks])
                    this.commit("tasksLoaded", state.tasks)
                }else{
                    this.commit("tasksLoaded", [...state.tasks])
                }
            }
        },
        taskPMUpdatedWs(state, item){
            let idTs=item.messageContent.id;
            let idPM=item.messageContent.idPM;
            let nomePM=item.messageContent.nomePM;
            state.tasks.forEach(ts=>{
                if(ts.id==idTs){
                    ts.nomePM=nomePM;
                    ts.idPM=idPM
                }
            })
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
        },
        tsAggiornatiWs(state, item){
            let ts=item.messageContent;

            ts.forEach(t=>{

                if(t.idTicketParent!=null && t.idTicketParent>0){
                    state.tasks.forEach(task=>{
                        if(task.idTicketParent==t.idTicketParent){
                            task.titoloLavoro=t.titoloLavoro;
                        }
                    })
                }
                if(t.idTicket!=null && t.idTicket>0){
                    state.tasks.forEach(task=>{
                        if(task.idTicket==t.idTicket){
                            task.titoloAttivita=t.titoloAttivita;
                        }
                    })
                }
            })


            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
        },
        startProgrammaTs(state, item){
            return item;
        },
        startRiprogrammaTs(state, item){
            return item;
        },
        managerNotificheCambiato(state, item){
            state.tasks.forEach(ts=>{
                if(ts.id==item.idTaskSprint){
                    ts.forcePm=true;
                    ts.idPmForzato=item.idPmForzato
                }
            })
            let imPM=sessionStorage.getItem('isPM')
            if(imPM==='true'){
                this.commit("taskLoadedPM", [...state.tasks])
                this.commit("tasksLoaded", state.tasks)
            }else{
                this.commit("tasksLoaded", [...state.tasks])
            }
        },
        storicoTSEsecutoreLoaded(state, item){
            return item;
        }
    },
    actions: {

        async loadStoricoSettimanaEsecutore({ commit }, filters) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                // commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getStoricoSettimana", {
                    startDate:filters.startDate,
                    endDate: filters.endDate,
                    idAccount:filters.idAccount
                }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let responseData = JSON.parse(response.data.result);

                commit("storicoTSEsecutoreLoaded", {
                    ts:responseData,
                    esecutore:filters.idAccount,
                    startDate:filters.startDate,
                    endDate: filters.endDate,
                });
                // commit("hideLoader");
                // commit('addMessage', {
                //     message: "VUEX loadTasks OK!",
                //     messageType: 'info'
                // });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadTasks Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async createTask({ commit }, task) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                //TODO: Impostare dinamicamente userID
                // task.idCreatedBy=Number.parseInt(sessionStorage.getItem("currentUserId"));
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/create", { ...task }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let idCreatedTask = response.data.result;
                if(task.startDate>moment().unix()){
                    task.tag="PROGRAMMATO";
                }
                let nuovoTask = { ...task, id: idCreatedTask };
                commit("tasksCreated", nuovoTask);
                commit("hideLoader");
                // commit('addMessage', {
                //     message: "VUEX loadTasks OK!",
                //     messageType: 'info'
                // });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadTasks Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async editTask({ commit }, task) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                //TODO: Impostare dinamicamente userID
                // task.idCreatedBy=Number.parseInt(sessionStorage.getItem("currentUserId"));
                // task.idAccount=Number.parseInt(sessionStorage.getItem("currentUserId"));
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/update", { ...task }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let nuovoTask = { ...task };
                commit("tasksUpdated", nuovoTask);
                commit("hideLoader");
                // commit('addMessage', {
                //     message: "VUEX loadTasks OK!",
                //     messageType: 'info'
                // });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadTasks Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async loadTasks({ commit }, filters) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getByOwner", {}, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let responseData = JSON.parse(response.data.result);
                //let tasks = responseData.filter(task => task.tag !== 'PROGRAMMATO');
                commit("tasksLoaded", responseData);
                commit("hideLoader");
                // commit('addMessage', {
                //     message: "VUEX loadTasks OK!",
                //     messageType: 'info'
                // });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadTasks Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async loadTasksForPM({ commit }, filters) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getAll", {}, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let responseData = JSON.parse(response.data.result);
                commit("tasksLoaded", responseData);
                commit("taskLoadedPM", responseData);
                commit("hideLoader");
                // commit('addMessage', {
                //     message: "VUEX loadTasks OK!",
                //     messageType: 'info'
                // });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadTasks Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async notificaStartWorking({ commit }, data) {
            setTimeout(async () => {
                try {
                    const config = {
                        headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                    };
                    commit("showLoader");


                    let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/updateStartWorking",data, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config });
                    let response = await request;
                    commit("hideLoader");
                    console.log(response);

                } catch (e) {
                    commit("hideLoader");
                    commit('addMessage', {
                        message: "VUEX updateStatus Error: " + e.message,
                        messageType: 'error'
                    });
                }
            }, 0)
        },
        async updateEffortEvaluation({ commit }, data) {
            setTimeout(async () => {
                try {
                    const config = {
                        headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                    };
                    commit("showLoader");


                    let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/updateEffortEvaluation",data, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config });
                    let response = await request;
                    commit("hideLoader");
                    console.log(response);

                } catch (e) {
                    commit("hideLoader");
                    commit('addMessage', {
                        message: "VUEX updateStatus Error: " + e.message,
                        messageType: 'error'
                    });
                }
            }, 0)
        },
        async requestEffortRevision({ commit }, data) {
            setTimeout(async () => {
                try {
                    const config = {
                        headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                    };
                    commit("showLoader");


                    let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/requestEffortRevision",data, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config });
                    let response = await request;
                    commit("hideLoader");
                    console.log(response);

                } catch (e) {
                    commit("hideLoader");
                    commit('addMessage', {
                        message: "VUEX updateStatus Error: " + e.message,
                        messageType: 'error'
                    });
                }
            }, 0)
        },
        async updateStatus({ commit }, data) {
            setTimeout(async () => {
                try {
                    const config = {
                        headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                    };
                    commit("showLoader");


                    let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/updateStatus", {
                        id: data.id,
                        status: data.taskStatus,
                        oldStatus: data.status,
                        prossimaSettimana: data.prossimaSettimana || false,
                        idTicket: data.idTicket,
                        descrizione: data.descrizione,
                        messaggio: data?.messaggio,
                        idTicketParent:data?.idTicketParent,
                        idOwner:data?.idOwner,
                        idPM:data?.idPM,
                        nomePm:data?.nomePM,
                        forcePM:data?.forcePM,
                        idPmForzato:data?.idPmForzato
                    }, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config });
                    let response = await request;
                    if (response.data.responseCode !== 200) {
                        throw new Error(response.data.dettagli)
                    }
                    let updatedTask = JSON.parse(response.data.result);
                    commit("statusUpdated", { id: data.id, status: data.taskStatus, startDate: updatedTask.startDate, endDate: updatedTask.startDate, tag: updatedTask.tag });
                    if (response.data.createNew || response.data.canCloseTicket) {
                        commit("tuttiITaskCompletati", { task:{...data}, createNew:response.data.createNew, canCloseTicket: response.data.canCloseTicket, force:true });
                    }
                    commit("hideLoader");
                    commit('addMessage', {
                        message: "Stato del task aggiornato correttamente!",
                        messageType: 'success'
                    });
                } catch (e) {
                    commit("hideLoader");
                    commit('addMessage', {
                        message: "VUEX updateStatus Error: " + e.message,
                        messageType: 'error'
                    });
                }
            }, 0)
        },

        async updateOwner({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/update", { id: data.taskId, status: data.status, idOwner: data.idOwner,
                    oldIdOwner:data.oldOwner, descrizione:data.descrizione, oldDescrizione:data.oldDescrizione, idTicket:data.idTicket, orePreviste:data.orePreviste, forcePM:data.forcePM,
                    idPmForzato:data.idPmForzato }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let updatedTask = JSON.parse(response.data.result);
                commit("ownerUpdated", { id: data.taskId, status: data.status, idOwner: data.idOwner, oldOwner: data.oldOwner, descrizione:data.descrizione });
                commit("hideLoader");
                commit('addMessage', {
                    message: "Esecutore del task aggiornato correttamente!",
                    messageType: 'success'
                });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX updateStatus Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async updateDOD({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/updateDOD", { ...data, idAccount: sessionStorage.getItem("currentUserId") }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                commit("hideLoader");
                commit('dodEdited', { id: data.idTaskSprint, descrizione: data.descrizione });
                commit('addMessage', {
                    message: "DOD modificata con successo!",
                    messageType: 'success'
                });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX updateDOD Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async eliminaTS({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/delete", {
                    id: data.idTask
                }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                commit("hideLoader");
                commit('taskEliminato', { id: data.idTask });
                commit('addMessage', {
                    message: "Task eliminato con successo!",
                    messageType: 'success'
                });
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX updateDOD Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async loadStoriaTask({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getStoricoTaskSprint", {
                    idTaskSprint: data.idTaskSprint
                }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let storia=JSON.parse(response.data.result)

                commit("storiaTaskLoaded", {
                    storia: storia,
                    idTaskSprint:data.idTaskSprint,
                    titoloLavoro:data.titoloLavoro,
                    titoloAttivita:data.titoloAttivita
                })
                commit("hideLoader");
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadStoriaTask Error: " + e.message,
                    messageType: 'error'
                });
            }
        },
        async loadStoriaTaskFromNotifica({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getStoricoTaskSprint", {
                    idTaskSprint: data.idTaskSprint
                }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let storia=JSON.parse(response.data.result)

                commit("storiaTaskLoadedFromNotifica", {
                    storia: storia,
                    titoloLavoro:data.titoloLavoro,
                    titoloAttivita:data.titoloAttivita
                })
                commit("hideLoader");
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadStoriaTask Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async loadStoriaTaskFromDettaglio({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getStoricoTaskSprint", {
                    idTaskSprint: data.idTaskSprint
                }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let storia=JSON.parse(response.data.result)

                commit("storiaTaskLoadedFromDettaglio", {
                    storia: storia
                })
                commit("hideLoader");
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX loadStoriaTask Error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        expandTaskSprint({ commit }, data) {
            commit('expandTaskSprint', data)
        },

        droppedTask({ commit }, data) {
            commit('droppedTask', data)
        },

        editTaskDOD({ commit }, data) {
            commit('editTaskDOD', data)
        },

        updateTaskPosition({ commit }, data) {
            commit('updateTaskPosition', data)
        },

        storeUpdateTasks({ commit }, data) {
            commit('storeUpdateTasks', data)
        },

        creaTaskSprint({commit}, data) {
            commit('creaTaskSprint', data);
        },

        startProgrammaTs({commit}, data) {
            commit('startProgrammaTs', data);
        },
        startRiprogrammaTs({commit}, data) {
            commit('startRiprogrammaTs', data);
        },

        async getDescrizioneLavoro({ commit }, data) {
            try {
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getDescrizioneLavoro", { ...data });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                commit("hideLoader");
                commit("showSimpleModal", {
                    titolo: 'Descrizione lavoro:',
                    descrizione: JSON.parse(response.data.dettagli).descrizioneLavoro
                })
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX getDescrizioneLavoro error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async getDettaglioTicket({ commit }, data) {
            try {
                commit("showLoader");
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getDettaglioTicket", { ...data });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }

                let dettagli = JSON.parse(response.data.dettagli);
                let descrizione = '';

                if (dettagli.manager) {
                    descrizione = '<b>PM - Responsabile: </b>' + dettagli.manager + "</br>"
                }

                if (dettagli.esecutori) {
                    descrizione += '<b>Esecutore: </b>' + dettagli.esecutori + "</br><br>"
                }

                descrizione += '<b>Descrizione:</b><br>' + dettagli.descrizioneTicket;
                commit("hideLoader");
                commit("showSimpleModal", {
                    titolo: 'Titolo: <br>' + dettagli.titoloTicket,
                    descrizione: descrizione
                })
            } catch (e) {
                commit("hideLoader");
                commit('addMessage', {
                    message: "VUEX getDettaglioTicket error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async refreshTasks({ commit }, data){
            const config = {
                headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
            };
            commit("showMiniLoader");
            try{
                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getLastUpdated", {
                    lastUpdate:data.lastFetch,
                    isPM:data.isPM
                }, { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }
                let responseData = JSON.parse(response.data.result);
                commit("taskRicaricati", responseData);
                commit("hideMiniLoader");
            }catch(ex){
                commit("hideMiniLoader");
                commit('addMessage', {
                    message: "refreshTasks error: " + ex.message,
                    messageType: 'error'
                });
            }

        },

        tasksCreatedFromWs({ commit }, data) {
            commit('tasksCreatedFromWs', data);
        },


        // async showDettaglioTicket({commit}, data){
        //     commit("showLoader");
        //     let request= axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/task-sprint/getDettaglioTicket", {...data});
        //     let response= await request;
        //     if(response.data.responseCode!==200){
        //         throw new Error(response.data.dettagli)
        //     }
        //     let dettagli=JSON.parse(response.data.dettagli);
        //     let descrizioneTicket='';
        //
        //     if(dettagli.manager){
        //         descrizioneTicket='<b>PM - Responsabile: </b>'+dettagli.manager+"</br>"
        //     }
        //
        //     if(dettagli.esecutori){
        //         descrizioneTicket+='<b>Esecutore: </b>'+dettagli.esecutori+"</br><br>"
        //     }
        //
        //     descrizioneTicket+='<b>Descrizione:</b><br>'+dettagli.descrizioneTicket;
        // },

        applicaFiltriClient({ commit }, filtri) {
            if (filtri.idEsecutore) {
                commit("filtraEsecutori", filtri.idEsecutore)
            }
            if (filtri.idLavoro || filtri.idAttivita) {
                commit("filtraTasks", filtri)
            }
            commit("filtriApplicati", filtri)
        },
        applicaFiltriRequest({ commit }, filtri) {
            commit("filtraRequest", filtri)
        },

        async aggiornaTaskSprint({commit},data){
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };

                let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/aggiornaTS", [ ...data ], { ...config });
                let response = await request;
                if (response.data.responseCode !== 200) {
                    throw new Error(response.data.dettagli)
                }

            } catch (e) {
                commit('addMessage', {
                    message: "VUEX aggiornaTaskSprint error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        tasksLoaded({ commit }, tasks) {
            commit("tasksLoaded", tasks)
        },
    },

    getters: {
        getByStatus: (state) => (status) => {
            return state.tasks.filter((el) => el.status === status);
        },
        getAllTasks: (state) => () => {
            return [...state.tasks];
        },
        getAllTasksForUser: (state) => (userId) => {
            return [...state.tasks.filter(ts=> ts.idOwner == userId)];
        },
        getByStatusAndUser: (state) => (status, userId) => {
            return state.tasks.filter((el) => el.status === status && el.idOwner == userId);
        },
        getFiltrati: (state) => (status, userId, filtri) => {
            let filtrati = state.tasks.filter((el) => {
                if (el.status === status && el.idOwner == userId) {
                    if (filtri.idAttivita !== -1) {
                        if (el.idTicket === filtri.idAttivita)
                            return el;
                    } else {
                        if (filtri.idLavoro !== -1) {
                            if (el.idTicketParent === filtri.idLavoro)
                                return el;
                        }
                    }
                }
            });
            return filtrati
        },
        getFiltriApplicati: (state) => (status, userId) => {
            if(!state.filtriClient.idAttivita)
                return undefined
            else
                return state.filtriClient
        },
        getFiltriRequest: (state) => (status, userId) => {
            return state.filtriRequest
        },
        getLastFetch: (state) => (status, userId) => {
            return state.lastFetch
        },
        getTaskById:(state)=>(taskId)=>{
            return state.tasks.filter((el) => el.id === taskId);
        }
    }
}

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

function epochToDate(epoch) {
    return moment.unix(epoch).format("DD/MM/YYYY HH:mm")
}

export { TaskSprintStore };